// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "code/chunk-" + {"64":"subapps/onboarding","266":"subapps/kb","757":"subapps/chat","825":"subapps/settings"}[chunkId] + "." + {"64":"e51cdd99cf58ec8d5222","266":"c9b9a7456a0724b143b3","757":"cb6ee63e1b4dce73e9fe","825":"e5504bcaf233caad18e9"}[chunkId] + ".css";
};